import {createApp} from 'vue'
import StafetDonationStepOne from './StafetDonationStepOne'

const el = '.kb-component--stafet-donation-step-one'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((StafetDonationStepOneDOM)=>{
            const component = createApp(StafetDonationStepOne).use(Store)
            component.mount(StafetDonationStepOneDOM)
        })
    }
}